import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

// Move fallback outside component to prevent recreating on every render
const fallbackProjects = [
  {
    title: "Visione intelligente per l'industria",
    subtitle: "Identificare e contare in ambienti imprevedibili...",
    image: "/assets/images/projects/1.png",
    details: "Un sistema di visione artificiale in grado di identificare oggetti, contarli e analizzarne le caratteristiche come distanza o area occupata. Ideale in contesti dove i sensori tradizionali non bastano, questo modello trova applicazione in ambienti complessi. Un esempio concreto? Il conteggio di noci di cocco su nastri trasportatori, ottimizzando la produzione in tempo reale."
  },
  {
    title: "Un agente telefonico che parla come te",
    subtitle: "Conversazioni naturali, interattive e automatizzate...",
    image: "/assets/images/projects/2.jpg",
    details: "Il chatbot telefonico basato su IA non solo parla, ma comprende e interagisce con gli utenti in modo naturale. È in grado di gestire interruzioni, adattarsi al tono della conversazione e raccogliere informazioni in modo efficace."
  },
  {
    title: "Un assistente legale inarrestabile",
    subtitle: "Ricerca legale in secondi, non in ore...",
    image: "/assets/images/projects/3.png",
    details: "Un chatbot legale basato su un sistema ad agente Multi-RAG che legge e comprende documenti legali in pochi secondi. Questo strumento fornisce risposte dettagliate, supporta nella stesura di report e semplifica la ricerca di normative o fonti rilevanti."
  },
  {
    title: "Marketing automatico senza limiti",
    subtitle: "Campagne che si ottimizzano da sole...",
    image: "/assets/images/projects/4.png",
    details: "Una piattaforma di marketing automation che utilizza l'intelligenza artificiale per creare, ottimizzare e gestire campagne pubblicitarie in autonomia."
  }
];

// Ensure we always have at least 3 projects for the preview section
const previewProjects = fallbackProjects.slice(0, 3);

export const useProjectsData = () => {
  const { t, ready, i18n } = useTranslation();
  
  // Use useMemo to prevent creating new array references on every render
  return useMemo(() => {
    console.log('useProjectsData - EFFECT TRIGGERED - ready:', ready, 'language:', i18n.language);
    
    if (!ready) {
      console.log('useProjectsData - i18n not ready, returning fallback projects');
      return fallbackProjects;
    }
    
    try {
      const translatedProjects = t('projects:items', { returnObjects: true }) as Array<{title: string; subtitle: string; image: string; details: string}>;
      console.log('useProjectsData - Raw translatedProjects from t():', translatedProjects);
      
      // Ensure we always return an array with valid data
      if (Array.isArray(translatedProjects) && translatedProjects.length > 0) {
        console.log('useProjectsData - Returning translated projects. Count:', translatedProjects.length);
        return translatedProjects;
      }
    } catch (error) {
      console.warn('useProjectsData - Failed to load translated projects, using fallback:', error);
    }
    
    console.log('useProjectsData - No valid translated projects, returning fallback projects');
    return fallbackProjects;
  }, [t, ready, i18n.language]);
};

// Export a hook specifically for preview projects (first 3)
export const usePreviewProjects = () => {
  const projects = useProjectsData();
  console.log('usePreviewProjects - Projects received:', projects.length);
  return useMemo(() => projects.slice(0, 3), [projects]);
};

// Keep the original export for backward compatibility, but it will be empty
export const PROJECTS_DATA: any[] = [];
